import { Injectable } from '@angular/core';

import { tableNames } from '../../app/app.constants';
import { GlobalVars } from '../../app/app.environment';
import { QueryModel } from '../../models/query';
import { FirebaseProvider } from '../firebase/firebase';


@Injectable()
export class WorkDaysProvider {

  constructor(
    public firebaseService: FirebaseProvider,
    public globalVars: GlobalVars,
  ) {}

  getAll() {
    return this.firebaseService.list(this.getBaseRoot());
  }

  getAllOnce() {
    return this.firebaseService.listOnce(this.getBaseRoot());
  }

  getAllByYear(year) {
    let beginDate = new Date(year, 0, 1, 0, 0, 0, 0);
    let endDate = new Date(year+1, 0, 1, 0, 0, 0, 0);
    endDate.setMilliseconds(endDate.getMilliseconds()-1);

    let query = new QueryModel();
      
    query.orderByChild = 'date';
    query.startAt = beginDate.getTime();
    query.endAt = endDate.getTime();

    return this.firebaseService.list(this.getBaseRoot(), query);
  }

  add(date) {
    this.firebaseService.push(this.getBaseRoot(), date)
  }

  delete(holiday) {
    this.firebaseService.remove(this.getBaseRoot(), holiday.key)
  }

  calculateWorkingDays() {}

  getBusinessDatesCount(sDate, eDate, beginDateHalfDay, endDateHalfDay) {
    return new Promise(resolve => {
      var startDate = new Date(sDate);
      var endDate = new Date(eDate);
    
      var count = 0;
      var curDate = startDate;
      while (curDate <= endDate) {
        var dayOfWeek = curDate.getDay();
        if (!(dayOfWeek == 6 || dayOfWeek == 0)) {
          count++;
          
          if (curDate.toDateString() == (new Date(sDate)).toDateString() && beginDateHalfDay) count -= 0.5;
          else if (curDate.toDateString() == (new Date(eDate)).toDateString() && endDateHalfDay) count -= 0.5;
        }
          
        curDate.setDate(curDate.getDate() + 1);
      }
  
      // *****************
      //return count;
  
      this.getAllOnce().subscribe(holidays => {

        startDate = new Date(sDate);
        endDate = new Date(eDate)

        holidays.forEach(holiday => {
  
          var date = new Date(holiday.date);
          var dayOfWeek = new Date(holiday.date).getDay();

          if (date >= startDate && date <= endDate) {
            if (!((dayOfWeek == 6) || (dayOfWeek == 0))) {
              count--;
  
              if (date.toDateString() == startDate.toDateString() && beginDateHalfDay) count += 0.5;
              else if (date.toDateString() == endDate.toDateString() && endDateHalfDay) count += 0.5;
            }
          }
  
          return false;
        })

        resolve(count);
      })
    })
    
    /*
    var festiusRef = this.afDatabase.database.ref('repositoris/' + this.globalVars.repositori + '/dies_festius/');

    return festiusRef.once('value', dataList => {
      dataList.forEach(data => {
        var dayOfWeek = new Date(data.key).getDay();
        if(data.key >= sDate && data.key <= eDate) {
          if(!((dayOfWeek == 6) || (dayOfWeek == 0))) {
            count--;

            if(data.key == sDate && this.dataIniciMitjaJornada) count += 0.5;
            else if(data.key == eDate && this.dataFinalMitjaJornada) count += 0.5;
          }
        }

        return false;
      });
    }).then(snap => {
      return Promise.resolve(count);
    });
    */
  }

  /**
   * Arrel base dins la base de dades.
   */
  private getBaseRoot(): string {
    return tableNames.Repo + '/' + this.globalVars.user.repo + '/' + tableNames.Holidays + '/';
  }
}



// WEBPACK FOOTER //
// ./src/providers/work-days/work-days.ts